import React, { Component } from "react"
import { LoadModalWithLabel } from "../modais"
import { withRouter } from "react-router-dom"
import {
  TextArea,
  SelectCustom,
  HttpError,
  Loading
} from "../../components"
import * as ApiHelper from "../../ApiHelper"
import * as constants from "../../constants"
import Util from "../../Util"
import { ToastContainer, ToastMessage } from "react-toastr"
class ProrrogacaoContratualForm extends Component {
  constructor() {
    super()
    this.onChangeFiscal = this.onChangeFiscal.bind(this)
    this.getFiscalWithId = this.getFiscalWithId.bind(this)
    this.onChangeContrato = this.onChangeContrato.bind(this)
    this.onChangeRazao = this.onChangeRazao.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.getInitialFields = this.getInitialFields.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false,
      showForm: false,
      fiscais: [],
      fiscal: "",
      contratos: [{ value: null, label: "" }],
      contrato: "",
      razao: ""
    }
    this.showSucessMessage = this.showSucessMessage.bind(this)
    this.toastFactory = React.createFactory(ToastMessage.animation)
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  showSucessMessage() {
    var message = ""
    var title = "Sucesso"
    if (this.props.isEditing) {
      message = "Prorrogação contratual atualizada com sucesso"
    } else {
      message = "Prorrogação contratual atualizada com sucesso"
    }
    this.container.success(title, message, {
      timeOut: 2000,
      extendedTimeOut: 3000
    })
  }
  showErrorMessage() {
    this.container.error(
      "Ocorreram erros",
      "Verifique os dados e tente novamente",
      {
        timeOut: 2000,
        extendedTimeOut: 3000
      }
    )
  }
  componentWillMount() {
    if (this.props.isEditing) {
      this.getInitialFields()
    } else {
      this.getFiscais()
    }
  }
  getFiscais() {
    if (!constants.userIsFiscal()) {
      ApiHelper.getFiscais((fiscais, error) => {
        if (fiscais) {
          this.setState(
            {
              fiscais: Util.mapFiscais(fiscais),
              showForm: true
            },
            () => {
              window.scrollTo(0, 0)
            }
          )
        } else {
          this.setState({
            httpError: error
          })
        }
      })
    } else {
      ApiHelper.getMe(() => {
        var contratos = Util.mapContratos(constants.getUserContratos())
        this.setState({
          fiscal: constants.getUserID(),
          showForm: true,
          contratos: contratos
        })
      })
    }
  }
  getInitialFields() {
    ApiHelper.getProrrogacaoContratualEdit(
      this.props.match.params.id,
      (data, error) => {
        if (data) {
          this.fillFields(data.prorrogacaoContratual)
          this.setState(
            {
              fiscais: data.fiscais,
              showForm: true
            },
            () => {
              var fiscalID = data.prorrogacaoContratual.contrato.fiscal_id
              var contratos = this.getFiscalWithId(fiscalID).contratos
              this.setState(
                {
                  contratos: Util.mapContratos(contratos),
                  fiscal: fiscalID
                },
                () => {
                  window.scrollTo(0, 0)
                }
              )
            }
          )
        } else {
          this.setState({
            httpError: error
          })
        }
      }
    )
  }
  fillFields(fields) {
    var currentFields = {
      razao: fields.razao,
      contrato: fields.num_contrato,
      num_contratoLabel: fields.contrato.num_contrato
    }
    this.setState(currentFields)
  }
  sendForm(event) {
    event.preventDefault()
    var params = {
      num_contrato: this.state.contrato,
      razao: this.state.razao
    }
    this.toggleLoadModal()
    if (this.props.isEditing) {
      ApiHelper.updateProrrogacaoContratual(
        this.props.match.params.id,
        params,
        error => {
          this.toggleLoadModal()
          if (error) {
            this.showErrorMessage()
            this.handleErrors(error)
          } else {
            this.showSucessMessage()
            Util.sleep(3000).then(() => {
              this.props.callBackAtaReuniao()
            })
          }
        }
      )
    } else {
      ApiHelper.sendNewProrrogacaoContratual(params, error => {
        this.toggleLoadModal()
        if (error) {
          this.showErrorMessage()
          this.handleErrors(error)
        } else {
          this.showSucessMessage()
          Util.sleep(3000).then(() => {
            this.props.callBackAtaReuniao()
          })
        }
      })
    }
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.erros
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  onChangeRazao(event) {
    var newValue = event.target.value
    this.setState({
      razaoError: "",
      razao: newValue
    })
  }
  getFiscalWithId(id) {
    var fiscalFound = ""
    this.state.fiscais.forEach(fiscal => {
      if (fiscal.value === parseInt(id, 10)) fiscalFound = fiscal
    })
    return fiscalFound
  }
  onChangeContrato(event) {
    var newValue = event.target.value
    this.setState({
      num_contratoError: "",
      contrato: newValue
    })
  }
  onChangeFiscal(event) {
    var newValue = event.target.value
    this.setState(
      {
        fiscal_idError: "",
        contrato: "",
        fiscal: newValue
      },
      () => {
        var contratos = this.getFiscalWithId(this.state.fiscal).contratos
        this.setState(
          {
            contratos: contratos ? Util.mapContratos(contratos) : []
          },
          () => {
            if (this.state.contratos.length === 1) {
              this.setState({
                fiscal_idError: "Este fiscal não possui contratos cadastrados"
              })
            }
          }
        )
      }
    )
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="container-fluid">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="container-fluid">
        <LoadModalWithLabel
          label="Aguarde..."
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <div>
          {this.state.showForm === false && <Loading />}
          {this.state.showForm === true && (
            <div className="card card-plain">
              <ToastContainer
                ref={input => {
                  this.container = input
                }}
                toastMessageFactory={this.toastFactory}
                className="toast-top-right"
                preventDuplicates={true}
              />
              <div className="card-header" data-background-color="as-blue">
                <h4 className="title">
                  {this.props.isEditing
                    ? "Editar prorrogação contratual"
                    : "Criar prorrogação contratual"}
                </h4>
                <p className="category">
                  {this.props.isEditing
                    ? "Prorrogação contratual do contrato: " +
                      this.state.num_contratoLabel
                    : "Criar nova prorrogação contratual"}
                </p>
              </div>
              <div className="card-content">
                <form>
                  <div className="row">
                    {!constants.userIsFiscal() && (
                      <SelectCustom
                        error={this.state.fiscal_idError}
                        sizeClass="col-md-4"
                        options={this.state.fiscais}
                        label="Selecione um fiscal"
                        name="fiscal"
                        value={this.state.fiscal}
                        onChange={this.onChangeFiscal}
                      />
                    )}
                  </div>
                  {this.state.contratos.length > 1 && (
                    <div>
                      <div className="row">
                        <SelectCustom
                          error={this.state.num_contratoError}
                          sizeClass="col-md-4"
                          options={this.state.contratos}
                          label={"Selecione um contrato"}
                          name={"contrato"}
                          value={this.state.contrato}
                          onChange={this.onChangeContrato}
                        />
                      </div>
                      <div className="row">
                        <TextArea
                          error={this.state.razaoError}
                          sizeClass="col-md-10"
                          subTitle="Razão da prorrogação contratual"
                          label=""
                          onChange={this.onChangeRazao}
                          value={this.state.razao}
                        />
                      </div>
                    </div>
                  )}
                  <button
                    onClick={this.sendForm}
                    type="submit"
                    className="btn btn-primary pull-right"
                    data-background-color="as-blue"
                  >
                    {this.props.isEditing ? "Salvar" : "Criar"}
                  </button>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}
export default withRouter(ProrrogacaoContratualForm)



// WEBPACK FOOTER //
// ./src/views/modais/ProrrogacaoContratualForm.js